var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { attrs: { id: "dashboard2" } },
    [
      _c(
        "div",
        { attrs: { id: "search-bar" } },
        [
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.keyword,
                expression: "keyword",
              },
            ],
            staticClass: "material-input",
            attrs: { type: "text", placeholder: "Search" },
            domProps: { value: _vm.keyword },
            on: {
              input: function ($event) {
                if ($event.target.composing) {
                  return
                }
                _vm.keyword = $event.target.value
              },
            },
          }),
          _c(
            "el-select",
            {
              attrs: { placeholder: "Select" },
              model: {
                value: _vm.perPage,
                callback: function ($$v) {
                  _vm.perPage = $$v
                },
                expression: "perPage",
              },
            },
            _vm._l(_vm.perPageOptions, function (item) {
              return _c("el-option", {
                key: item.value,
                attrs: { label: item.label, value: item.value },
              })
            }),
            1
          ),
          _c(
            "el-select",
            {
              attrs: { placeholder: "Sort by" },
              model: {
                value: _vm.sortBy,
                callback: function ($$v) {
                  _vm.sortBy = $$v
                },
                expression: "sortBy",
              },
            },
            _vm._l(_vm.sortByOptions, function (item) {
              return _c("el-option", {
                key: item.value,
                attrs: { label: item.label, value: item.value },
              })
            }),
            1
          ),
          _c(
            "el-select",
            {
              attrs: { placeholder: "Sorting Direction" },
              model: {
                value: _vm.sortDirection,
                callback: function ($$v) {
                  _vm.sortDirection = $$v
                },
                expression: "sortDirection",
              },
            },
            _vm._l(_vm.sortByDirectionOptions, function (item) {
              return _c("el-option", {
                key: item.value,
                attrs: { label: item.label, value: item.value },
              })
            }),
            1
          ),
          _c(
            "el-button",
            {
              attrs: { type: "success" },
              on: {
                click: function ($event) {
                  return _vm.fetchData(_vm.data)
                },
              },
            },
            [_vm._v("Search")]
          ),
          _c(
            "el-button",
            { attrs: { type: "danger" }, on: { click: _vm.resetAll } },
            [_vm._v("Reset All")]
          ),
        ],
        1
      ),
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: !_vm.loading,
              expression: "!loading",
            },
          ],
          attrs: { id: "filters-container" },
        },
        [
          _c(
            "div",
            { attrs: { id: "filters" } },
            [
              _c(
                "span",
                { staticClass: "filter", attrs: { label: "Order Status" } },
                [
                  _vm._v(" Order Status "),
                  _c(
                    "el-select",
                    {
                      on: {
                        change: function ($event) {
                          return _vm.fetchData(_vm.data)
                        },
                      },
                      model: {
                        value: _vm.orderStatus,
                        callback: function ($$v) {
                          _vm.orderStatus = $$v
                        },
                        expression: "orderStatus",
                      },
                    },
                    _vm._l(_vm.orderStatusOptions, function (item) {
                      return _c("el-option", {
                        key: item.value,
                        attrs: { label: item.label, value: item.value },
                      })
                    }),
                    1
                  ),
                ],
                1
              ),
              _vm._l(_vm.filterOptions, function (filter, index) {
                return _c(
                  "span",
                  { key: filter.property, staticClass: "filter" },
                  [
                    _c("el-switch", {
                      on: {
                        change: function ($event) {
                          return _vm.updateFilter(filter)
                        },
                      },
                      model: {
                        value: filter.checked,
                        callback: function ($$v) {
                          _vm.$set(filter, "checked", $$v)
                        },
                        expression: "filter.checked",
                      },
                    }),
                    _c("span", { staticClass: "filter-content" }, [
                      _vm._v(" " + _vm._s(filter.label) + " "),
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: filter.value,
                            expression: "filter.value",
                          },
                        ],
                        ref: function (el) {
                          _vm.filterByRefs[index] = el
                        },
                        refInFor: true,
                        attrs: { disabled: !filter.checked, type: "text" },
                        domProps: { value: filter.value },
                        on: {
                          change: function ($event) {
                            return _vm.fetchData(_vm.data)
                          },
                          input: function ($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.$set(filter, "value", $event.target.value)
                          },
                        },
                      }),
                    ]),
                  ],
                  1
                )
              }),
            ],
            2
          ),
        ]
      ),
      _c(
        "div",
        { attrs: { id: "table" } },
        [
          _c(
            "el-table",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.loading,
                  expression: "loading",
                },
              ],
              staticStyle: { width: "100%" },
              attrs: { data: _vm.tableData },
            },
            [
              _c("el-table-column", {
                attrs: { label: "Order" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (ref) {
                      var row = ref.row
                      return [
                        _c("p", [
                          _c("small", [_vm._v("Order:")]),
                          _vm._v(" "),
                          _c("b", [
                            _vm._v(_vm._s(row.orderId ? row.orderId : "-")),
                          ]),
                          _c("br"),
                          _vm._v(
                            "    " +
                              _vm._s(
                                row.subjectAddress + row.subjectAddress2 + ", "
                              ) +
                              " "
                          ),
                          _c("br"),
                          _vm._v(
                            "    " +
                              _vm._s(
                                row.subjectCity +
                                  ", " +
                                  row.subjectState +
                                  ", " +
                                  row.subjectPostalCode
                              ) +
                              " "
                          ),
                        ]),
                        _c("p", [
                          _c("small", [_vm._v("Client:")]),
                          _vm._v(
                            " " +
                              _vm._s(
                                row.client.name + " (" + row.clientId + ")"
                              ) +
                              " "
                          ),
                        ]),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: { label: "Status" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (ref) {
                      var row = ref.row
                      return [
                        _c(
                          "p",
                          {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: row.deleted === true,
                                expression: "row.deleted === true",
                              },
                            ],
                          },
                          [_c("strong", [_vm._v("*** DELETED ***")])]
                        ),
                        _c("p", [
                          _c("small", [_vm._v("Status:")]),
                          _vm._v(
                            " " +
                              _vm._s(
                                row.orderStatusNavigation
                                  ? row.orderStatusNavigation.name
                                  : "-"
                              ) +
                              " "
                          ),
                        ]),
                        _c("p", [
                          _c("small", [_vm._v("Type:")]),
                          _vm._v(
                            " " +
                              _vm._s(
                                row.orderTypeNavigation
                                  ? row.orderTypeNavigation.description
                                  : "-"
                              ) +
                              " "
                          ),
                        ]),
                        _c("p", [
                          _c("small", [_vm._v("Loan #:")]),
                          _vm._v(
                            " " +
                              _vm._s(
                                row.loanNumber !== null ? row.loanNumber : "-"
                              ) +
                              " "
                          ),
                        ]),
                        _c("p", [
                          _c("small", [_vm._v("Seller/LPA:")]),
                          _vm._v(
                            " " +
                              _vm._s(row.sellerId ? row.sellerId : "-") +
                              " / " +
                              _vm._s(row.lpaKey ? row.lpaKey : "-") +
                              " "
                          ),
                        ]),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: { label: "Dates" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (ref) {
                      var row = ref.row
                      return [
                        _c("p", [
                          _c("small", [_vm._v("Created:")]),
                          _vm._v(
                            " " +
                              _vm._s(_vm._f("parseUtc")(row.createDate)) +
                              " "
                          ),
                        ]),
                        _c("p", [
                          _c("small", [_vm._v("Appointment:")]),
                          _vm._v(
                            " " +
                              _vm._s(_vm._f("parseUtc")(row.appointmentDate)) +
                              " "
                          ),
                        ]),
                        _c("p", [
                          _c("small", [_vm._v("Inspection:")]),
                          _vm._v(
                            " " +
                              _vm._s(_vm._f("parseUtc")(row.inspectionDate)) +
                              " "
                          ),
                        ]),
                        _c("p", [
                          _c("small", [_vm._v("Modified:")]),
                          _vm._v(
                            " " +
                              _vm._s(_vm._f("parseUtc")(row.lastModifiedDate)) +
                              " "
                          ),
                        ]),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: { label: "Names" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (ref) {
                      var row = ref.row
                      return [
                        _c("p", [
                          _c("small", [_vm._v("Client:")]),
                          _vm._v(
                            " " +
                              _vm._s(row.client ? row.client.company : "-") +
                              " "
                          ),
                        ]),
                        _c("p", [
                          _c("small", [_vm._v("Vendor:")]),
                          _vm._v(
                            " " +
                              _vm._s(row.vendor ? row.vendor.name : "-") +
                              " "
                          ),
                        ]),
                        _c("p", [
                          _c("small", [_vm._v("Lender:")]),
                          _vm._v(
                            " " +
                              _vm._s(row.lenderName ? row.lenderName : "-") +
                              " "
                          ),
                        ]),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: { label: "Fees" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (ref) {
                      var row = ref.row
                      return [
                        _c("p", [
                          _c("small", [_vm._v("Client:")]),
                          _vm._v(" $" + _vm._s(row.orderFee) + " "),
                        ]),
                        _c("p", [
                          _c("small", [_vm._v("Vendor:")]),
                          _vm._v(" $" + _vm._s(row.vendorFee) + " "),
                        ]),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  align: "center",
                  label: "Actions",
                  width: "110",
                  fixed: "right",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (ref) {
                      var row = ref.row
                      return [
                        _c(
                          "router-link",
                          { attrs: { to: "/orders/edit/" + row.orderId } },
                          [
                            _c("el-button", {
                              attrs: {
                                type: "primary",
                                circle: "",
                                plain: "",
                                size: "mini",
                                icon: "el-icon-edit",
                              },
                            }),
                          ],
                          1
                        ),
                        _c("el-button", {
                          staticStyle: { "margin-left": "5px" },
                          attrs: {
                            type: "warning",
                            size: "mini",
                            icon: "el-icon-delete",
                            circle: "",
                            plain: "",
                          },
                          on: {
                            click: function ($event) {
                              return _vm.showDeleteDialog(row.orderId)
                            },
                          },
                        }),
                      ]
                    },
                  },
                ]),
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "div",
        { attrs: { id: "pagination" } },
        [
          _c("el-pagination", {
            attrs: {
              layout: "prev, pager, next",
              pageCount: _vm.totalPages,
              "page-size": _vm.perPage,
            },
            on: { "current-change": _vm.updatePage },
          }),
          _c("small", [
            _vm._v(
              " Showing " +
                _vm._s(_vm.pageItems) +
                " of " +
                _vm._s(_vm.totalItems) +
                " results "
            ),
          ]),
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          staticClass: "dialog-confirm-vendor-fee",
          attrs: {
            "close-on-click-modal": false,
            title: _vm.deleteTitle,
            visible: _vm.dialogDeleteOrder,
            width: "60%",
          },
          on: {
            "update:visible": function ($event) {
              _vm.dialogDeleteOrder = $event
            },
          },
        },
        [
          _c("el-input", {
            attrs: {
              placeholder: "Add reason for Cancelling the order...",
              type: "textarea",
            },
            model: {
              value: _vm.deleteReason,
              callback: function ($$v) {
                _vm.deleteReason = $$v
              },
              expression: "deleteReason",
            },
          }),
          _c(
            "div",
            {
              staticStyle: {
                display: "flex",
                "justify-content": "right",
                "margin-top": "15pt",
              },
            },
            [
              _c(
                "el-button",
                {
                  attrs: { type: "success", disabled: _vm.deleteReason === "" },
                  on: { click: _vm.handleDelete },
                },
                [
                  _vm._v(
                    " Cancel and Deactivate Order " +
                      _vm._s(_vm.deleteOrderId) +
                      " "
                  ),
                ]
              ),
              _c(
                "el-button",
                {
                  attrs: { type: "warning" },
                  on: { click: _vm.closeDeleteDialog },
                },
                [_vm._v(" Close ")]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }